<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        class="ml-1"
        v-bind="attrs"
        v-on="on"
        :color="approved ? 'light-green darken-3' : 'grey lighten-1'"
        small
      >
        {{ approved ? "mdi-check-decagram" : "mdi-alert-decagram" }}
      </v-icon>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "ApprovalIcon",
  props: {
    approved: {
      type: Boolean,
      default: false,
    },
    approvedBy: {
      type: String,
      default: "",
    },
    approvedAt: {
      type: [String, Date],
      default: "",
    },
  },
  computed: {
    tooltipText() {
      if (!this.approved) {
        return "Iniciativa não aprovada";
      }
      let tooltip = "Iniciativa aprovada";

      if (
        (this.$store.getters.getLoggedUser.roles.includes("content_approver") ||
          this.$store.getters.getLoggedUser.roles.includes("admin")) &&
        this.approvedBy &&
        this.approvedAt
      ) {
        const date = new Date(this.approvedAt).toLocaleDateString("pt-BR");

        return `${tooltip} por ${this.approvedBy} em ${date}`;
      }
      return tooltip;
    },
  },
};
</script>
